import { captureError } from '@repo/common/utils/web-tracing';
import { NodeSelection, Plugin, TextSelection } from 'prosemirror-state';
import scrollIntoView from 'smooth-scroll-into-view-if-needed';
import Extension from '../lib/Extension';

type DOMNode = InstanceType<typeof window.Node>;

export default class ScrollToHeading extends Extension {
	get name() {
		return 'scroll-to-heading';
	}

	get plugins() {
		return [
			new Plugin({
				props: {
					handleScrollToSelection(view) {
						const { state } = view;
						const { selection } = state;

						let dom: DOMNode | null = null;

						if (selection instanceof NodeSelection) {
							dom = view.nodeDOM(selection.$anchor.pos);
						} else if (selection instanceof TextSelection) {
							dom = view.domAtPos(selection.$anchor.pos)?.node;
							// If dom is text, we need to get the parent element
							if (dom?.nodeType === 3) {
								dom = dom.parentElement;
							}
						}

						if (!dom) {
							return false;
						}

						try {
							// give it a bit of time for the browser to stabilize the layout
							requestAnimationFrame(() => {
								scrollIntoView(dom as HTMLElement, {
									scrollMode: 'if-needed',
									block: 'start',
								});
							});
						} catch (e) {
							// scrollIntoView might throw an error if the node is not in the DOM
							// we shouldn't be scrolling to a node that's not in the DOM
							// the only situation this has happened so far is when vite is hot reloading
							captureError(e);
						}

						return true;
					},
				},
			}),
		];
	}
}
